import { SfaSalesGroupEntityLinkContainerModel } from '../../../../../../models/aggregates/sfa/salesGroup/SfaSalesGroupEntityLinkContainer.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../../shared';

@Injectable({
    providedIn: 'root'
})
export class SfaSalesGroupEntityLinkService extends BaseApiTemplateService<SfaSalesGroupEntityLinkContainerModel> {
    static readonly SALES_GROUP_ENTIY_LINK_SUB_PATH = 'sales-group-entity-links/';

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + SfaSalesGroupEntityLinkService.SALES_GROUP_ENTIY_LINK_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + SfaSalesGroupEntityLinkService.SALES_GROUP_ENTIY_LINK_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + SfaSalesGroupEntityLinkService.SALES_GROUP_ENTIY_LINK_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}